module.exports = __webpack_public_path__ + "img/Dantam Makeover 26.a5ef0ef2.jpg";